import React from 'react';
import { Controller } from 'react-hook-form';
import Input from "./Input";

const EmailInput = ({ name, control, displayName, required, placeholder, errors, disabled }) => {
  return <Controller
    name={name}
    control={control}
    rules={{
      required: required ? `${displayName} is required` : null,
      pattern: {
        value: /^\S+@\S+\.\S+$/,
        message: "Please enter a valid email"
      }
    }}
    render={({ field: { ref, ...field } }) => (
      <Input
        {...field}
        type="email"
        placeholder={placeholder}
        invalid={!!errors}
        disabled={disabled}
      />
    )}
  />
}

export default EmailInput;